import { useMeta } from '@nuxtjs/composition-api';
export default function useHtmlMeta() {
  var _useNuxt2App = useNuxt2App(),
    _useNuxt2App$i18n = _useNuxt2App.i18n,
    locale = _useNuxt2App$i18n.locale,
    defaultLocale = _useNuxt2App$i18n.defaultLocale;
  function setHtmlLocale() {
    useMeta({
      htmlAttrs: {
        lang: locale !== null && locale !== void 0 ? locale : defaultLocale
      }
    });
  }
  return {
    setHtmlLocale: setHtmlLocale
  };
}